<template>
	<div
		:aria-active="isActive"
		:class="[{selected: isActive}]"
		role="menuitemradio"
		class="menu-nav-item"
		tabindex="0"
		@click="onNavigate"
		@keydown.space.prevent="onNavigate"
	>
		<div class="menu-nav-item-icon-wrapper">
			<t-dot :hideDot="!isNew" color="yellow" style="margin-left: 16px;">
				<t-timpex-icon
					:icon="icon"
					:type="iconType"
					:size="iconSize"
					:class="[{selected: isActive}]"
					class="menu-nav-item-icon"
				/>
			</t-dot>
		</div>
		<span :class="[{selected: isActive, bold: bold}]" class="menu-nav-item-inner">
			<slot>{{value}}</slot>
		</span>

		<div v-show="hasCount" class="menu-nav-item-count">
			<t-pill :color="pillColor" isSolid>
				{{count}}
			</t-pill>
		</div>

	</div>
</template>

<script>
import menuItemMixin from './menuItemMixin';
import TPill from '../badges/TPill';
import TDot from '../badges/TDot';
import TTimpexIcon from '../timpex/icons/TTimpexIcon';
export default {
	name: 'TMenuNavItem',
	components: { TDot, TPill, TTimpexIcon },
	mixins: [menuItemMixin],
	props: {
		id: String,
		to: [ String, Object ],
		isNew: Boolean,
		count: {
			type: Number,
			default: 0,
		},
		icon: {
			type: String,
			default: 'filter'
		},
		iconType: String,
		iconSize: {
			type: String,
			default: 'sm'
		},
		active: {
			type: Boolean,
			default: false
		},
	},
	computed: {
		hasCount() {
			return this.count > 0;
		},
		pillColor() {
			return this.isNew ? 'yellow' : 'neutral';
		},
		isActive() {
			if (this.to) {
				if (this.$route.params.searchId) {
					return this.to && this.to.params && this.to.params.searchId === this.$route.params.searchId;
				} else if (typeof this.to === 'object') {
					if (this.to.path) return this.$route.path.includes(this.to.path);
					if (this.to.name) return this.$route.name === this.to.name;
				} else if (this.to) {
					return this.$route.path.includes(this.to);
				}
			}

			return this.active;
		}
	},
	methods: {
		onNavigate() {
			this.$emit('click');
			if (!this.to || this.isActive) return;
			this.$router.push(this.to);
		}
	}
};
</script>

<style lang="scss" scoped>
@import '~@/components/evergreen/scss/colors';
@import '~@/components/evergreen/scss/text';
	.menu-nav-item {
		@extend %font-families-ui;
		@extend %text-small;
		user-select: none;
		color: get-color($text, 'muted');
		margin-top: 0;
		cursor: pointer;
		outline: none;
		display: flex;
		box-sizing: border-box;
		align-items: center;
		&.selected {
			background-color: rgba(16, 112, 202, 0.06);
			.menu-nav-item-count {
				color: get-color($blue, 'base');
			}
		}
		&:hover {
			background-color: rgba(67, 90, 111, 0.04);
		}
		&:active {
			background-color: rgba(16, 112, 202, 0.06);
		}
		&:focus {
			background-color: rgba(16, 112, 202, 0.04);
		}
	}

	.menu-nav-item-icon-wrapper {
		display: flex;
		width: 27px;
		justify-content: center;
	}

	.menu-nav-item-icon {
		color: get-color($icon, 'default');
		box-sizing: border-box;
		&.selected {
			color: get-color($blue, 'base') !important;
		}
	}

	.menu-nav-item-inner {
		height: 32px;
		line-height: 32px;
		flex:1;
		margin-left: 16px;
		margin-right: 16px;
		box-sizing: border-box;
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		font-weight: 500;
		&.bold {
			color: get-color($neutral, 'dark');
			font-weight: 600;
		}
		&.selected {
			color: get-color($blue, 'base');
		}
	}

	.menu-nav-item-count {
		min-width: 20px;
		margin-right: 16px;
		color: get-color($neutral, 'dark');
	}
</style>
